import { combineReducers } from 'redux';
import { default as auth } from './auth';
import commissary from './commissary';
import { default as common } from './common';
import controlCenter from './control-center';
import facility from './facility';
import profile from './profile';
import { default as siteMessage } from './site-message';
import users from './users';
export default combineReducers({
  auth: auth,
  common: common,
  facility: facility,
  siteMessage: siteMessage,
  users: users,
  commissary: commissary,
  profile: profile,
  controlCenter: controlCenter
});